import { Directive, ElementRef, Input } from '@angular/core';
import { RequestedPermissions } from '../../../../models/roles-and-permissions';
import { PermissionService } from '../../../../services/permission/permission.service';
import { ComponentBase } from '../../../../base-classes/componet-base';

@Directive({
  selector: '[hideIfUnauthorized]'
})
export class HideIfUnauthorizedDirective extends ComponentBase {
  @Input() hideIfUnauthorized: RequestedPermissions;
  constructor(private permissionService: PermissionService, private el: ElementRef) {
    super();
  }

  ngOnInit() {
    let sub = this.permissionService.getPermissionsForUser()
      .subscribe((res) => {
        if (!res.isAuthorized(this.hideIfUnauthorized)) {
          this.el.nativeElement.style.display = 'none';
        }
      });
    this.addSubscription(sub);
  }
}
